import { hearthHarmony as hearthHarmonyBase } from "@thirdparty/companies";

import { GtbCustomApp } from "../gtb/types";
import { towne } from "../towne";

export const hearthHarmony: GtbCustomApp = {
  ...hearthHarmonyBase,
  routes: towne.routes,
};
